<style scoped>
.emptyBox {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.emptyImg {
  width: 5.07rem;
  height: 4.1rem;
  background: url("~assets/artHealing.png") no-repeat center/cover;
  margin-top: 1.5rem;
  margin-bottom: 0.62rem;
  font-size: 0.3rem;
  color: #6f6f6f;
}
.list {
  padding: 0 0.28rem;
  background: #ffffff;
  border-radius: 0.2rem;
  margin: 0.3rem;
}
.item {
  padding: 0.3rem 0;
  display: flex;

  border-bottom: 0.01rem solid #eeeeee;
}
.item:last-child {
  border: 0;
}
img {
  width: 2.2rem;
  min-width: 2.2rem;
  height: 2.48rem;
  border-radius: 0.1rem;
  margin-right: 0.26rem;
  object-fit: cover;
}
.itemRight {
  width: 4rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.itemTitle {
  font-size: 0.34rem;
  color: #333;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  margin-bottom: 0.24rem;
}
.itemTagline {
  font-size: 0.26rem;
  color: #333;
}

.itemBottomBox {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}

.num {
  font-size: 0.24rem;
  color: #666;
}

.btn {
  width: 1.85rem;
  height: 0.62rem;
  background: #ffffff;
  border: 0.01rem solid #408bfb;
  border-radius: 0.31rem;
  font-size: 0.26rem;
  color: #408bfb;
  text-align: center;
  line-height: 0.62rem;
}

.btn.active {
  background: #408bfb;
  color: #fff;
}
</style>
<template>
  <div style="padding-top: 0.98rem">
    <topbar text="电子书"></topbar>
    <div class="emptyBox" v-if="emptyStatus">
      <div class="emptyImg"></div>
      <div class="emptyName">目前还没有内容哦~</div>
    </div>
    <div class="list">
      <div class="item" @click="to(item.bookId)" v-for="(item, index) in list" :key="index">
        <img :src="EnvUrl + item.bookPic" alt="" class="itemIcon" />
        <div class="itemRight">
          <div>
            <div class="itemTitle">{{ item.title }}</div>
            <div class="itemTagline">{{ item.tagline }}</div>
          </div>

          <div class="itemBottomBox">
            <div class="num">{{ item.readCount }}人学习</div>
            <div class="btn active" v-if="item.payType == 1">
              购买 ￥{{ item.bookPrice }}
            </div>
            <div class="btn" v-else>免费</div>
          </div>
        </div>
      </div>
    </div>
    <no-more-data :noMoreData="noMoreData"></no-more-data>
  </div>
</template>
<script>
import { getSource, getSources } from "../api";

import noMoreData from "components/no-more-data";
import topbar from "components/topbar";
import moment from "moment/moment";

import { Swiper, Slide } from "vue-swiper-component";
import { serialize } from "utils/index";

export default {
  data() {
    return {
      //                EnvUrl: `https://oml9ntix5.qnssl.com/`, // 七牛图片
      EnvUrl: `https://cdn.ysqingxin.com/`,
      pageIndex: 1,
      pageSize: 10,
      noMoreData: false,
      isLoading: false,
      emptyStatus: false,
      count: 0,
      list: [],
    };
  },
  components: {
    noMoreData,
    topbar,
    Swiper,
    Slide,
  },
  filters: {
    time(value) {
      let transTime = moment(value).format("YYYY-MM-DD HH:mm:ss");
      return transTime;
    },
  },
  computed: {},
  methods: {
    to(id) {
      this.$router.push(`/eBookDetail?id=${id}`);
    },
    handleScroll() {
      //                console.log(11)
      let scrolltop =
        document.documentElement.scrollTop || document.body.scrollTop;
      let bottomOfWindow =
        document.documentElement.offsetHeight -
          scrolltop -
          window.innerHeight <=
        200;
      if (bottomOfWindow && this.isLoading == false) {
        if (this.pageIndex >= Math.ceil(this.count / this.pageSize)) {
          this.noMoreData = true;
        } else {
          this.isLoading = true;
          this.pageIndex = this.pageIndex + 1;
          this.getList();
        }
      }
    },
    async getList() {
      let obj = {};
      obj.pageIndex = this.pageIndex;
      obj.pageSize = this.pageSize;
      // obj.userId = this.userId;
      obj.companyId = localStorage.getItem("companyId")
        ? localStorage.getItem("companyId")
        : "";
      let data = await getSources("/bear-scale/api/microBook/getBookList", obj);
      if (data.status === 0) {
        this.isLoading = false;
        this.count = data.count;
        this.list = [...this.list, ...data.bookList];
        if (data.bookList.length == 0) {
          this.emptyStatus = true;
        } else {
          console.log(111111);
          if (this.pageIndex >= Math.ceil(this.count / this.pageSize)) {
            console.log("显示");
            this.noMoreData = true;
          } else {
            console.log(2);
            this.noMoreData = false;
          }
        }
      } else {
        alert(data.msg);
      }
    },
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll); //监听页面滚动事件
  },
  mounted() {
    this.userId = localStorage.getItem("userId");
    this.getList();
    window.addEventListener("scroll", this.handleScroll); //监听页面滚动事件
  },
};
</script>



// WEBPACK FOOTER //
// src/components/eBook.vue?62c7a9c3